import { render, staticRenderFns } from "./updateBtn.vue?vue&type=template&id=5c17312c&scoped=true&"
import script from "./updateBtn.vue?vue&type=script&lang=js&"
export * from "./updateBtn.vue?vue&type=script&lang=js&"
import style0 from "./updateBtn.vue?vue&type=style&index=0&id=5c17312c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c17312c",
  null
  
)

export default component.exports